import axios from '../requester';

export const METRICS_ROUTES = {
  METADATA: '/api/metrics/metadata',
  GRAPH: '/api/metrics/graph'
};

export const getMetricsMetadata = async params => {
  const { data } = await axios.get(METRICS_ROUTES.METADATA, {
    params
  });
  return data;
};

export const getMetricsGraph = async ({
  periodName,
  from,
  to,
  aggregation,
  repos,
  automations,
  actions
}) => {
  const { data } = await axios.get(METRICS_ROUTES.GRAPH, {
    params: { periodName, from, to, aggregation, repos, automations, actions }
  });
  return data;
};
